import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetDate, GetTime } from '../../../app/AppUtils';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelUnsubscriptions({ disabled, jsonData }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        if (jsonData) {
            // Header row
            setExcelHeaderRow([
                resourceFinal[appLanguage].words.ACTIVITY,
                resourceFinal[appLanguage].words.PERFORMANCE,
                `${resourceFinal[appLanguage].words.START}${resourceFinal[appLanguage].words.TIME.toLowerCase()}`,
                resourceFinal[appLanguage].words.EMAIL,
                resourceFinal[appLanguage].words.PHONENUMBER,
                resourceFinal[appLanguage].words.NUMBER,
                resourceFinal[appLanguage].words.NAME_FIRST,
                resourceFinal[appLanguage].words.NAME_INSERTION,
                resourceFinal[appLanguage].words.NAME_LAST,
                resourceFinal[appLanguage].words.UNSUBSCRIBED_DATE,
                resourceFinal[appLanguage].words.UNSUBSCRIBED_BY,
            ]);

            // Data rows
            let dataRows = [];

            jsonData?.forEach(item => {
                dataRows.push(
                    Object.keys(item).map(key => {
                        const value = item[key];

                        if (key.toLowerCase().includes("date") || key.toLowerCase().includes("time")) {
                            return value === null ? "" : `${GetDate(value)} (${GetTime(value)})`;
                        }

                        return value === null ? "" : value;
                    })
                );
            });

            setExcelDataRows(dataRows);

            // File name
            setExcelFileName(`${resourceFinal[appLanguage].words.REPORT_UNSUBSCRIPTIONS} - ${jsonData[0]?.activityName}`);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={excelFileName}
            buttonText={`${resourceFinal[appLanguage].words.EXPORT} ${resourceFinal[appLanguage].words.EXCEL.toLowerCase()}`}
            disabledCondition={disabled}
        />

    );
}
